import React from "react";

import { Button } from "@/components/form/Button/Button";
import { TextField } from "@/components/form/text-field/TextField";
import { ModalCloseCross } from "@/components/modal/components/ModalCloseCross";
import { useOpenModal } from "@/components/modal/utils/openModal";
import { useFormFactory } from "@/hooks/useFormFactory";

import { useSendPromoCode } from "./hooks";
import { PromoCodeFormSchema } from "./models";

export const PromoCodeForm: React.FC = () => {
  const { removeOne } = useOpenModal();
  const { mutate } = useSendPromoCode();
  const { onSubmitHandler, register } = useFormFactory({
    mutate,
    schema: PromoCodeFormSchema,
  });

  return (
    <form className="flex flex-col gap-4" onSubmit={onSubmitHandler}>
      <ModalCloseCross absolute onClose={removeOne} />
      <span className="text-base">Promo code</span>
      <TextField
        label="Enter promo code"
        autoComplete="off"
        {...register("code")}
      />
      <Button fullWidth type="submit" onHoverVariant="gradient-flip">
        Submit
      </Button>
    </form>
  );
};
